module.exports = __webpack_public_path__ + "static/media/icon-luft.2a901c23.svg";